<div class="contact-btn" [class.contact-btn-bottom]="contactBtnMoveBottom" #contactBtn>
  <ssc-contact-btn [showContactButton]="showContactButton"></ssc-contact-btn>
</div>

<div
  class="information"
  sscIntersectionObserver
  [threshold]="0.52"
  [rootMargin]="'0px 0px 180px 0px'"
  (isIntersecting)="setContactBtnMoveBottom($event)"
>
  <ssc-language-selector></ssc-language-selector>

  <a
    sscIntersectionObserver
    (isIntersecting)="setImprintMoveLeft($event)"
    class="body-4 imprint"
    href="{{ 'FOOTER.IMPRINT_LINK' | translate }}"
    target="_blank"
    #imprint
    [class.imprint-left]="imprintMoveLeft"
    >{{ 'FOOTER.IMPRINT' | translate }}</a
  >
</div>
